import React from "react";
import './Popup.css';

const Popup = props => {
    return (
        <div className="popup-box">
            <div className="box">
                <div>{props.content}</div>
                <p className="close" onClick={props.handleClose}>Close</p>
            </div>
        </div>
    );
};

export default Popup;